import Bag from "../util/Bag.js";
class StoreBag extends Bag {
  add(...toAdd) {
    if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
      toAdd = toAdd[0];
    }
    return super.add(...toAdd.filter((record) => record.isPersistable));
  }
}
;
StoreBag._$name = "StoreBag";
export {
  StoreBag as default
};
